import { render, staticRenderFns } from "./SummaryYearTable.vue?vue&type=template&id=5c410b9e&scoped=true"
import script from "./SummaryYearTable.vue?vue&type=script&lang=js"
export * from "./SummaryYearTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c410b9e",
  null
  
)

export default component.exports